import FormatBoldIcon from "@mui/icons-material/FormatBold";
import { SvgIconProps, useTheme } from "@mui/material";

export const BoldIcon: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return <FormatBoldIcon {...props} style={{ color: theme.palette.brandedTypography.textColor }} />;
};

export default BoldIcon;
